import { render, staticRenderFns } from "./AwinAd.vue?vue&type=template&id=6b5d3cb8"
import script from "./AwinAd.vue?vue&type=script&lang=js"
export * from "./AwinAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports